/* eslint-disable max-len */
export const identifiersInformation = {
  whatInformationDoesThisInclude: 'Name, email address, phone number, username, physical address,\n'
    + '                          device identifier, IP address, government-issued identification number,\n'
    + '                          date of birth/age, license plate number, tokenized payment information, \n'
    + '                          social media handle, and other similar identifiers.\n',
  whereDoWeCollectItFrom: [
    'Directly from you or the devices you use to access digital services, such as websites, mobile applications, and applications for connected devices.',
    'Other customers that may provide us with your information to recommend a product or service, ship products to you, or list you as a recipient of products or services.',
    'Companies that provide services on our behalf (e.g., installers).',
    'Security and fraud prevention services that help us confirm that transactions are valid and otherwise help us protect our assets and you.',
    'Marketing companies that help us learn about our customers and the devices they use to access digital content.',
    'Companies that supplement our customer records with additional information.',
    'Shipping providers that update address information.',
    'Social media platforms.',
    'Advertising companies and content publishers that present you with our ads.',
    'Payment and transaction processors.',
    'Communications and mailing vendors.',
    'The signals emitted by your mobile devices when you travel through our stores.'
  ],
  whyDoWeCollectIt: ['Fulfilling orders and processing returns.',
    'Customer care.',
    'Administering contests and promotions.',
    'Registering you for a website or program.',
    'Communicating with you.',
    'Improving our products and services, including improving store layouts and digital content.',
    'Learning about customer trends and interests.',
    'Personalizing digital content.',
    'Delivering marketing communications and advertising.',
    'Identifying the devices you use to access digital content.',
    'Fraud prevention, security, and asset protection.'],
  whoDoWeShareItWith: ['Service providers that process information on our behalf, such as shipping vendors, providers of digital analytics services, and fraud prevention.',
    'Manufacturers of products and providers of extended warranty services.',
    'Joint marketing partners.',
    'Financial services companies, such as for home improvement loans, processing payments, and for managing The Home Depot credit card accounts.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Advertising partners.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.',
    'Our affiliates and subsidiaries.']
};

export const internetActivityInformation = {
  whatInformationDoesThisInclude: 'Browsing history, search history, information about your interaction with our websites, applications, electronic communications, or advertisements, and information about your activities when using our in-store WiFi. Session replay software may be used to record and replay your interaction.',
  whereDoWeCollectItFrom: [
    'Directly from you or the devices you use to access digital services, such as websites, mobile applications, and applications for connected devices.',
    'Marketing companies that help us learn about our customers and the devices they use to access digital content.',
    'Companies that supplement our customer records with additional information.',
    'Social media platforms.',
    'Advertising companies and content publishers that present you with our ads. '
  ],
  whyDoWeCollectIt: [
    'Fulfilling orders and processing returns.',
    'Customer care.',
    'Communicating with you. ',
    'Administering contests and promotions.',
    'Improving our products and services, including improving store layouts and digital content.',
    'Learning about customer trends and interests.',
    'Personalizing digital content.',
    'Delivering marketing communications and advertising. ',
    'Identifying the devices you use to access digital content.',
    'Fraud prevention, security, and asset protection.'
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as providers of digital analytics services and fraud prevention services.',
    'Joint marketing partners.',
    'Advertising partners.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Our affiliates and subsidiaries.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  '
  ]
};

export const commercialInformation = {
  whatInformationDoesThisInclude: 'Products or services purchased, purchasing history, products or services you like, reviews you submit, or where you shop.',
  whereDoWeCollectItFrom: [
    'Directly from you or the devices you use to access digital services, such as websites, mobile applications, and applications for connected devices.',
    'Other customers that may provide us with your information to recommend a product or service, ship products to you, or list you as a recipient of products or services.',
    'Companies that provide services on our behalf (e.g., installers).',
    'Security and fraud prevention services that help us confirm that transactions are valid and otherwise help us protect our assets and you. ',
    'Marketing companies that help us learn about our customers and the devices they use to access digital content.',
    'Companies that supplement our customer records with additional information.',
    'Social media platforms.',
    'Advertising companies and content publishers that present you with our ads. '
  ],
  whyDoWeCollectIt: [
    'Fulfilling orders and processing returns.',
    'Customer care.',
    'Administering contests and promotions.',
    'Registering you for a website or program. ',
    'Communicating with you. ',
    'Improving our products and services, including improving store layouts and digital content.',
    'Learning about customer trends and interests.',
    'Personalizing digital content.',
    'Delivering marketing communications and advertising. ',
    'Identifying the devices you use to access digital content.',
    'Fraud prevention, security, and asset protection. '
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as shipping vendors, providers of digital analytics services, and fraud prevention services.',
    'Manufacturers of products and providers of extended warranty services.',
    'Financial services companies, such as for home improvement loans, processing payments, and for managing The Home Depot credit card accounts.',
    'Joint marketing partners.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Advertising partners.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  ',
    'Our affiliates and subsidiaries.'
  ]
};

export const businessInformation = {
  whatInformationDoesThisInclude: 'Business information that we collect from you, such as business name, business phone number, business address, business website, and your association with our loyalty programs.',
  whereDoWeCollectItFrom: [
    'Directly from you or the devices you use to access digital services, such as websites, mobile applications, and applications for connected devices.',
    'Security and fraud prevention services that help us confirm that transactions are valid and otherwise help us protect our assets and you.',
    'Marketing companies that help us learn about our customers and the devices they use to access digital content.',
    'Companies that supplement our customer records with additional information.',
    'Social media platforms.',
    'Advertising companies and content publishers that present you with our ads.'
  ],
  whyDoWeCollectIt: [
    'Fulfilling orders and processing returns.',
    'Customer care.',
    'Administering contests and promotions.',
    'Registering you for a website or program.',
    'Communicating with you.',
    'Improving our products and services, including improving store layouts and digital content.',
    'Learning about customer trends and interests.',
    'Personalizing digital content.',
    'Delivering marketing communications and advertising.',
    'Identifying the devices you use to access digital content.',
    'Fraud prevention, security, and asset protection.'
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as shipping vendors, providers of digital analytics services, and fraud prevention services.',
    'Manufacturers of products and providers of extended warranty services.',
    'Financial services companies, such as for home improvement loans, processing payments, and for managing The Home Depot credit card accounts.',
    'Joint marketing partners.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Advertising partners.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.',
    'Our affiliates and subsidiaries.'
  ]
};

export const paymentInformation = {
  whatInformationDoesThisInclude: 'Credit or debit card, check, PayPal account, or gift card, as well as available credit for The Home Depot credit card.',
  whereDoWeCollectItFrom: [
    'Directly from you.',
    'From financial institutions, payment processors, and other providers of financial products and services that we work with to provide you with financial services and offers.',
    'Companies that provide services on our behalf.'
  ],
  whyDoWeCollectIt: [
    'Fulfilling orders and processing returns.',
    'Customer care.',
    'Communicating with you regarding payment status.',
    'Collecting payments on behalf of our financial service providers.',
    'Fraud prevention, security, and asset protection. '
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as data storage providers.',
    'Financial services companies, such as for home improvement loans, processing payments, and for managing The Home Depot credit card accounts.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  ',
    'Our affiliates and subsidiaries.'
  ]
};

export const demographicInformation = {
  whatInformationDoesThisInclude: 'Age, race, ethnicity, and gender.',
  whereDoWeCollectItFrom: [
    'Directly from you.',
    'Companies that provide services on our behalf (e.g., installers).',
    'Marketing companies that help us learn about our customers and the devices they use to access digital content.',
    'Companies that supplement our customer records with additional information.',
    'Social media platforms.',
    'Advertising companies and content publishers that present you with our ads. ',
    'Other customers that may provide us with your information to recommend a product or service, ship products to you, or list you as a recipient of products or services.'
  ],
  whyDoWeCollectIt: [
    'Improving our products and services, including improving store layouts and digital content.',
    'Communicating with you.',
    'Customer care.',
    'Administering contests and promotions.',
    'Learning about customer trends and interests.',
    'Personalizing digital content.',
    'Delivering marketing communications and advertising. ',
    'Fraud prevention, security, and asset protection. '
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as shipping vendors, providers of digital analytics services, and fraud prevention services.',
    'Joint marketing partners.',
    'Advisors and consultants.',
    'Advertising partners.',
    'Any successor to all or part of our business.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  ',
    'Our affiliates and subsidiaries.'
  ]
};

export const locationInformation = {
  whatInformationDoesThisInclude: 'Location based on IP address or mobile device location information. (Please see the <a href="#TrackingTools">Our Tracking Tools</a> section for additional information.)',
  whereDoWeCollectItFrom: [
    'Directly from you or the devices you use to access digital services, such as websites, mobile applications, and applications for connected devices.',
    'Security and fraud prevention services that help us confirm that transactions are valid and otherwise help us protect our assets and you. ',
    'Marketing companies that help us learn about our customers and the devices they use to access digital content.',
    'Companies that supplement our customer records with additional information.',
    'Advertising companies and content publishers that present you with our ads.',
    'The signals emitted by your mobile devices when you travel through our stores. '
  ],
  whyDoWeCollectIt: [
    'Communicating with you.',
    'Customer care.',
    'Improving our products and services, including improving store layouts and digital content.',
    'Administering contests and promotions.',
    'Learning about customer trends and interests.',
    'Personalizing digital content.',
    'Delivering marketing communications and advertising. ',
    'Identifying the devices you use to access digital content.',
    'Fraud prevention, security, and asset protection. '
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as providers of digital analytics services, and fraud prevention services.',
    'Advisors and consultants.',
    'Advertising partners.',
    'Joint marketing partners.',
    'Any successor to all or part of our business.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  ',
    'Our affiliates and subsidiaries.'
  ]
};

export const employmentInformation = {
  whatInformationDoesThisInclude: 'Profession, trade, or line of business.',
  whereDoWeCollectItFrom: [
    'Directly from you.',
    'Other customers that may provide us with your information to recommend a product or service, ship products to you, or reference you in association with products or services, including financial services.',
    'Companies that supplement our customer records with additional information.'
  ],
  whyDoWeCollectIt: [
    'Fulfilling orders and processing returns.',
    'Registering you for a website or program. ',
    'Communicating with you. ',
    'Learning about customer trends and interests.',
    'Personalizing digital content.',
    'Fraud prevention, security, and asset protection. '
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as data storage providers and fraud prevention providers.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Law enforcement and other entities as we deem reasonably necessary to comply with law.',
    'Our affiliates and subsidiaries.'
  ]
};

export const videoAndAudioRecordingInformation = {
  whatInformationDoesThisInclude: 'Video recordings of your activities in and around our stores, parking lots and facilities; Audio recordings of customer care calls made or received using our communications equipment.',
  whereDoWeCollectItFrom: [
    'Via cameras deployed in our stores (e.g., CCTV), in parking lots, and at our warehouses and other facilities.',
    'Via call recordings. '
  ],
  whyDoWeCollectIt: [
    'Improving our products and services, including improving store layouts and digital content.',
    'Customer care and software-based customer care analysis.',
    'To operate and improve our business.',
    'Learning about customer trends and interests.',
    'Fraud prevention, security, and asset protection. ',
    'Monitoring use of technology in compliance with our policies and practices.',
    'Complying with laws and regulations, and cooperating with law enforcement related to enforcement of laws and regulations.',
    'Training.'
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as security and fraud prevention services.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  ',
    'Our affiliates and subsidiaries.'
  ]
};

export const biometricInformation = {
  whatInformationDoesThisInclude: 'Facial recognition.',
  whereDoWeCollectItFrom: [
    'Via cameras at select stores, in parking lots, and at other facilities as permitted under applicable laws. '
  ],
  whyDoWeCollectIt: [
    'Fraud prevention, security, and asset protection. '
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as security and fraud prevention services.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  ',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Our affiliates and subsidiaries.'
  ]
};

export const propertyInformation = {
  whatInformationDoesThisInclude: 'Home and property measurements, square footage, public record information, ownership information, estimated home value, and lot size.',
  whereDoWeCollectItFrom: [
    'Directly from you.',
    'Public records.',
    'Suppliers of property information, such as online property databases. ',
    'Companies that supplement our customer records with additional information.',
    'Companies that provide services on our behalf (e.g., installers and others that communicate with you about projects).'
  ],
  whyDoWeCollectIt: [
    'Fulfilling orders and processing returns.',
    'Customer care.',
    'Administering contests and promotions.',
    'Registering you for a website or program. ',
    'Communicating with you. ',
    'Improving our products and services, including improving store layouts and digital content.',
    'Learning about customer trends and interests.',
    'Personalizing digital content.',
    'Delivering marketing communications and advertising. ',
    'Identifying the devices you use to access digital content.',
    'Fraud prevention, security, and asset protection.'
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as shipping vendors, providers of digital analytics services, and fraud prevention services.',
    'Manufacturers of products and providers of extended warranty services.',
    'Joint marketing partners.',
    'Financial services companies, such as for home improvement loans, processing payments, and for managing The Home Depot credit card accounts.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Advertising partners.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  ',
    'Our affiliates and subsidiaries.'
  ]
};

export const inferencesInformation = {
  whatInformationDoesThisInclude: 'Preferences, interests, and other characteristics.',
  whereDoWeCollectItFrom: [
    'Directly from you. ',
    'Companies that provide services on our behalf (e.g., installers and others that communicate with you about projects).',
    'Marketing companies that help us learn about our customers.',
    'Companies that supplement our customer records with additional information.',
    'Social media platforms.',
    'Advertising companies and content publishers that present you with our ads. ',
    'By analyzing the information we collect about you and other customers.'
  ],
  whyDoWeCollectIt: [
    'Communicating with you. ',
    'Customer care.',
    'Improving our products and services, including improving our store layout and digital content.',
    'Learning about customer trends and interests.',
    'Administering contests and promotions.',
    'Personalizing digital content.',
    'Delivering marketing communications and advertising. ',
    'Identifying the devices you use to access digital content.',
    'Fraud prevention, security, and asset protection. '
  ],
  whoDoWeShareItWith: [
    'Service providers that process information on our behalf, such as shipping vendors, providers of digital analytics services, and fraud prevention services.',
    'Joint marketing partners.',
    'Any successor to all or part of our business.',
    'Advisors and consultants.',
    'Advertising partners.',
    'Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.  ',
    'Our affiliates and subsidiaries.'
  ]
};

export const informationThatMayBeConsideredSpi = {
  whatInformationDoesThisInclude: 'Account login credentials, biometrics, race, ethnicity, government identification numbers, and precise geolocation.',
  whereDoWeCollectItFrom: [
    'See relevant disclosures above regarding Identifiers (for account login credentials and government identification numbers), Biometric Information, Demographic Information (for race and ethnicity), and Location Information (for precise geolocation).',
  ],
  whyDoWeCollectIt: [
    'See relevant disclosures above regarding Identifiers (for account login credentials and government identification numbers), Biometric Information, Demographic Information (for race and ethnicity), and Location Information (for precise geolocation).'
  ],
  whoDoWeShareItWith: [
    'See relevant disclosures above regarding Identifiers (for account login credentials and government identification numbers), Biometric Information, Demographic Information (for race and ethnicity), and Location Information (for precise geolocation).'
  ]
};

export const submenuOptions = [
  {
    name: 'Table of Contents',
    value: ''
  },
  {
    name: 'About This Statement',
    value: '#AboutThisStatement'
  },
  {
    name: 'What Do We Collect?',
    value: '#WhatDoWeCollect'
  },
  {
    name: 'How Do We Collect Information?',
    value: '#HowDoWeCollectInformation'
  },
  {
    name: 'How Do We Use Information?',
    value: '#HowDoWeUseInformation'
  },
  {
    name: 'Information Disclosures',
    value: '#InformationDisclosures'
  },
  {
    name: 'Manage Marketing Preferences',
    value: '#ManageMarketingPreferences'
  },
  {
    name: 'Our Sites and Children',
    value: '#OurSitesAndChildren'
  },
  {
    name: 'State Privacy Rights & Report',
    value: '#YourStatePrivacyRights'
  },
  {
    name: 'Security',
    value: '#Security'
  },
  {
    name: 'Links',
    value: '#Links'
  },
  {
    name: 'Contact Us',
    value: '#ContactUs'
  },
  {
    name: 'Our Tracking Tools',
    value: '#TrackingTools'
  },
  {
    name: 'Automated License Plate Recognition (“ALPR”) Usage and Privacy Policy',
    value: '#ALPR'
  },
  {
    name: 'My Account Registration and Use',
    value: '#MyAccountRegistrationAndUse'
  },
  {
    name: 'The Home Depot Foundation',
    value: '#TheHomeDepotFoundation'
  },
  {
    name: 'Information for Applicants',
    value: '#InformationForApplicants'
  }
];

const template = {
  whatInformationDoesThisInclude: '',
  whereDoWeCollectItFrom: [],
  whyDoWeCollectIt: [],
  whoDoWeShareItWith: []
};
